import { Column } from "@albertsons/uds/molecule/Table/Table.types";
import { TableData } from "../utils/historyLogDbApi";

export const historyTableColumns: Column<TableData>[] = [
  { id: "sourceProfile", label: "Source Profile", value: "sourceProfile", sortable: false },
  { id: "targetProfile", label: "Target Profile", value: "targetProfile", sortable: false },
  { id: "targetRegion", label: "Target Region", value: "targetRegion", sortable: false },
  { id: "process", label: "Process", value: "process", sortable: false },
  { id: "status", label: "Status", value: "status", sortable: false },
  { id: "MA_DataLoad_Ts_UTC", label: "MA_DataLoad_Ts_UTC", value: "MA_Dataload_ts_UTC", sortable: false },
  { id: "user", label: "User", value: "user", sortable: false },
];
